var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"order-details-drawer-wrapper"},[_c('div',{staticClass:"order-details-drawer-title"},[_vm._v(" Pedido "+_vm._s(_vm.order.orderId)+" ")]),_c('div',{staticClass:"order-details-drawer-details"},[_c('checkout-info',{attrs:{"order":_vm.order,"products":_vm.products,"user":_vm.user}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }